import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./common/mixin";
import "@/common/AddPrototype";
import "@/assets/style/index.scss";
import "vant/lib/index.css";

Vue.config.productionTip = false;

import { Lazyload, Button } from "vant";
Vue.use(Button);
Vue.use(Lazyload, {
  preLoad: 1,
  error: require("@/assets/images/默认图.png"),
  loading: require("@/assets/images/默认图.png"),
  attempt: 1
});

import Vconsole from "vconsole";
// if (process.env.NODE_ENV === "development") {
//   const vConsole = new Vconsole();
//   Vue.prototype.$vconsole = vConsole;
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
